/** Écran « compact » = mise en page TÉLÉPHONE : étroit, OU peu haut (téléphone
 *  tenu en paysage). Doit rester aligné sur le point « md » de tailwind.config.ts. */
export function isCompactScreen(): boolean {
  if (typeof window === 'undefined') return false
  return window.innerWidth < 768 || window.innerHeight < 521
}
